import React, { useId, type ReactNode } from "react";
import { kebabCase } from "lodash-es";
import {
  filterKeyEntityClassNames,
  filterKeyEntityEnum,
  type FilterKeyEntity,
} from "../../FilterManagement/filterKey";

export interface FilterEntitySectionProps {
  entity: FilterKeyEntity;
  children: ReactNode;
}

const filterEntitySectionTitles: Record<FilterKeyEntity, string> = {
  [filterKeyEntityEnum.FINDING]: "Seemplicity Findings Filters",
  [filterKeyEntityEnum.REMEDIATION_ITEM]: "Remediation Items Filters",
};

const filterEntitySectionIcons: Record<FilterKeyEntity, string> = {
  [filterKeyEntityEnum.FINDING]: "seem-icon-manualfinding",
  [filterKeyEntityEnum.REMEDIATION_ITEM]: "seem-icon-remediation",
};

const FilterEntitySection: React.FC<FilterEntitySectionProps> = ({
  entity,
  children,
}) => {
  const titleId = useId();

  return (
    <div
      className={`filter-entity-section ${filterKeyEntityClassNames[entity]}`}
      data-testid={`filter-entity-section-${kebabCase(entity)}`}
      role={"group"}
      aria-labelledby={titleId}
    >
      <div className={"filter-entity-section-header"}>
        <span className={"filter-entity-section-badge"}>
          <i className={`seem-icon ${filterEntitySectionIcons[entity]}`} />
        </span>
        <span id={titleId} className={"filter-entity-section-title"}>
          {filterEntitySectionTitles[entity]}
        </span>
      </div>
      <div className={"filter-entity-section-body"}>{children}</div>
    </div>
  );
};

export default FilterEntitySection;
